import React, { useState, useEffect } from 'react'
import Breadcrumbs from '../../components/Global/Breadcrumbs'
import { Container, Card, Row, Col } from 'reactstrap'
import Datatable from './components/Datatable'
import FlujoChart from '../../components/charts/FlujoChart'
import ProgramadasDashboard from './components/ProgramadasDashboard'
import ApiService from '../../data/services/ApiService'
import CurrencyFormat from 'react-currency-format'

const Index = () => {
    const [year, setYear] = useState(new Date().getFullYear())
    const [totalFacturado, setTotalFacturado] = useState(0)
    const [chartSeries, setChartSeries] = useState({})
    const [categories, setCategories] = useState([])

    useEffect(() => {
        (async () => {
            await _loadGraph()
        })()

        // eslint-disable-next-line
    }, [year])

    const _loadGraph = async () => {
        const fromDate = new Date(`${year.toString()}/01/01`)
        const toDate = new Date(`${year.toString()}/12/31`)
        const response = await ApiService.obtenerGraficaAnual({ fromDate, toDate })
        const { series, categories: cats } = response.data

        setChartSeries(series || {})
        setCategories(cats || [])
        setTotalFacturado(
            (series?.facturado || []).reduce((acc, v) => acc + parseFloat(v || 0), 0)
        )
    }

    const _changeYearInput = (e) => {
        setYear(e.target.value)
    }

    const _getYears = () => {
        const year = new Date().getFullYear()
        let years = []

        for (var i = year; i >= (year - 10); i--) {
            years.push(i)
        }

        return years.map((item, key) => {
            return (<option key={key} value={item}>{item}</option>)
        })
    }

    return(
        <React.Fragment>        
            <Container fluid>
                <Breadcrumbs
                    title="Facturación"
                    breadcrumbItem={`Facturas`}
                    parentLink={`/facturas`}
                />

                <Card>
                    <Row>
                        <Col sm={8}>
                            <FlujoChart series={chartSeries} categories={categories} />
                        </Col>

                        <Col sm={4} className="graph-totals">
                            <strong>Total facturado en {year}</strong> <br />
                            <span>
                                <CurrencyFormat
                                    value={totalFacturado}
                                    displayType="text"
                                    thousandSeparator
                                    prefix="$"
                                    decimalScale={2}
                                />
                            </span>

                            <select
                                onChange={_changeYearInput}
                                className="custom-select">
                                { _getYears() }
                            </select>
                        </Col>
                    </Row>
                </Card>

                <ProgramadasDashboard />

                <Datatable year={year} />
            </Container>
        </React.Fragment>
    )
}

export default Index
